import { useEffect, useState } from "react";
import { fetchMarketComparison } from "../services/api";

export function useOverview(listingId, radius = 25) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!listingId) return;
    setLoading(true);
    setError(null);
    fetchMarketComparison(listingId, radius)
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [listingId, radius]);

  return { data, loading, error };
}